export const setAssetBrowserProps = (assetBrowserProps) => ({
  type: 'SET_ASSET_BROWSER_PROPS', assetBrowserProps
});
